import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class AvoidTagsFilter extends Vue {
  @Prop({ default: () => [] }) availableTags;
  @Prop({ default: () => [] }) selectedTags;
  @Prop({ default: false }) isOnlyDisplay;

  isTagSelected(tagId) {
    return this.selectedTags.find((tag) => tag.id === tagId);
  }

  selectTag(tag) {
    if (!this.isOnlyDisplay) this.$emit("select-tag", tag);
  }
}
